import { Injectable } from '@angular/core';
import { GeoPoint } from '@core/const';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { CityActions } from '../store/actions';
import { StateWithCity } from '../store/city-state';
import { CitySelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class UserGeoPointFacade {
  constructor(private store: Store<StateWithCity>) {}

  setGeoPoint(geoPoint: GeoPoint): void {
    this.store.dispatch(new CityActions.UserGeoPointUpdate(geoPoint));
  }

  getGeoPoint(): Observable<GeoPoint> {
    return this.store.pipe(select(CitySelectors.getGeoPointState));
  }
}
